import { Component, EventEmitter, OnInit, Output, input, ChangeDetectionStrategy } from '@angular/core';
import { Employee } from '@coin/shared/core/util-models';
import { Observable } from 'rxjs';
import { ActionDef } from '@ngxs/store';
import { OrganisationService } from '../../../models/organisation-service.model';

@Component({
  selector: 'customer-org-tree-overview-items',
  templateUrl: './org-tree-overview-items.component.html',
  styleUrls: ['./org-tree-overview-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrgTreeOverviewItemsComponent implements OnInit {
  readonly rootEmployee = input<Employee>(undefined);
  readonly selectedEmployeeId = input<string>(undefined);
  readonly level = input<number>(undefined);
  readonly lastParent = input(false);
  readonly service = input<OrganisationService>(undefined);
  readonly seasonId = input<string>(undefined);
  readonly customOpenEmployeeInViewAction = input<ActionDef>(undefined);
  @Output() itemSelect = new EventEmitter<void>();

  public heads$: Observable<Employee[]>;

  ngOnInit(): void {
    this.loadChildOrganizations();
  }

  private loadChildOrganizations(): void {
    const rootEmployee = this.rootEmployee();
    if (rootEmployee) {
      this.heads$ = this.service().getChildOrganisations(rootEmployee?.orgCode, this.seasonId());
    }
  }
}
